export const shared = {
  invalidLinkMissingParams: 'Érvénytelen hivatkozás. Hiányzó paraméterek.',
  errorLoadingDocument: 'Hiba történt a dokumentum betöltése közben.',
  passwordProtected: 'Jelszóvédett dokumentum',
  enterPassword: 'Ez a dokumentum jelszóval védett. Kérjük, adja meg a jelszót a megtekintéshez.',
  password: 'Jelszó',
  viewDocument: 'Dokumentum megtekintése',
  invalidPassword: 'Érvénytelen jelszó.',
  incorrectPasswordTryAgain: 'Helytelen jelszó. Kérjük, próbálja újra.',
  download: 'Letöltés',
  captchaRequired: 'Kérjük, igazolja, hogy nem robot.',
  captchaError: 'Hiba történt a robot-ellenőrzés során. Kérjük, próbálja újra.',
  captchaExpired: 'Az ellenőrzés lejárt. Kérjük, igazolja újra, hogy nem robot.',
  captchaVerificationFailed: 'A robot-ellenőrzés érvénytelen. Kérjük, próbálja újra.'
}
